"use client";
import { cn as e } from "../../design/cn.js";
import { Button as t } from "../../design/button/index.js";
import { Tooltip as n } from "../../design/tooltip/Tooltip.js";
import * as r from "react";
import { jsx as i } from "react/jsx-runtime";
// src/components/data-table/DataTableExpandable.tsx
var a = ({ isExpanded: n, onToggle: r, disabled: a = !1, className: o }) => /* @__PURE__ */ i(t.IconButton, {
	"aria-label": n ? "Collapse row" : "Expand row",
	icon: "ChevronRight",
	size: "sm",
	className: e(n && "rotate-90", o),
	onClick: (e) => {
		e.stopPropagation(), a || r();
	},
	variant: "ghost",
	disabled: a
});
a.displayName = "ExpandToggle";
var o = "bg-primary/5", s = "bg-muted/40", c = "shadow-[inset_3px_0_0_0_var(--primary)]", l = "[&>td:first-child]:shadow-[inset_3px_0_0_0_var(--primary)]", u = ({ isExpanded: t, children: n, colSpan: a, className: o, accent: s = !0 }) => {
	let c = r.useRef(null), [l, u] = r.useState(0);
	return r.useEffect(() => {
		c.current && u(t ? c.current.scrollHeight : 0);
	}, [t, n]), /* @__PURE__ */ i("tr", {
		className: e("transition-all duration-300 ease-in-out", s && t && "bg-muted/40", o),
		children: /* @__PURE__ */ i("td", {
			colSpan: a,
			className: e("p-0 border-0 overflow-hidden", s && t && "shadow-[inset_3px_0_0_0_var(--primary)]", t && "border-b border-border"),
			style: {
				height: l,
				opacity: +!!t,
				transition: "height 300ms ease-in-out, opacity 300ms ease-in-out"
			},
			children: /* @__PURE__ */ i("div", {
				ref: c,
				className: e("transition-transform duration-300 ease-in-out", t ? "translate-y-0" : "-translate-y-2"),
				children: n
			})
		})
	});
};
u.displayName = "ExpandedRow";
var d = ({ children: t, maxWidth: a = "200px", singleLineOnly: o = !0, className: s }) => {
	let c = r.useRef(null), [l, u] = r.useState(!1);
	r.useEffect(() => {
		if (c.current) {
			let e = c.current;
			u(e.scrollWidth > e.clientWidth || e.scrollHeight > e.clientHeight);
		}
	}, [t]);
	let d = /* @__PURE__ */ i("div", {
		ref: c,
		className: e("block", o ? "truncate whitespace-nowrap" : "truncate", s),
		style: { maxWidth: a },
		children: t
	});
	return l ? /* @__PURE__ */ i(n, {
		content: /* @__PURE__ */ i("div", {
			className: "max-w-sm wrap-break-word whitespace-normal",
			children: t
		}),
		children: d
	}) : d;
};
d.displayName = "TruncatedCell";
export { c as EXPANDED_ACCENT_BAR, s as EXPANDED_PANEL_BG, o as EXPANDED_ROW_ACCENT, l as EXPANDED_TRIGGER_BAR, a as ExpandToggle, u as ExpandedRow, d as TruncatedCell };

//# sourceMappingURL=DataTableExpandable.js.map